export const setSend=()=>({
    type:'SEND'
});
export const gotError=(error)=>({
    type:'GOT_ERROR',
    error
});
export const expectResult=(result)=>({
    type:'EXPECT_RESULT',
    result
});
export const setGotResponse=(result)=>({
    type:'GOT_RESPONSE',
    result
});
export const openProducts=()=>({
    type:'OPEN_PRODUCTS'
});
export const closeProducts=()=>({
    type:'CLOSE_PRODUCTS'
});